<template>
    <div>

        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >

            <rkm-area
                v-if="form && paciente.nome"
                title="Identificação"
                type="fieldset"
                no-margin-top
            >
                <rkm-row>
                    <rkm-col class="flex-grow-1">
                        <rkm-row>
                            <rkm-col>
                                <h4>
                                    {{ paciente.nome }}
                                    <strong v-if="paciente.prefereNomeSocial">
                                        ({{ paciente.nomeSocial }})
                                    </strong>
                                </h4>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="3">
                                <p>
                                    <strong>Prontuário: </strong>
                                    <template v-if="paciente.prontuario">
                                        {{ paciente.prontuario }}
                                    </template>
                                    <template v-else>
                                        <i>Não informado</i>
                                    </template>
                                </p>
                                <p>
                                    <strong>Sexo:</strong>
                                    <template>
                                        {{ paciente.sexo }}
                                    </template>
                                </p>
                            </rkm-col>

                            <rkm-col cols="3">
                                <p>
                                    <strong>CPF: </strong>
                                    <template v-if="paciente.cpf">
                                        {{ paciente.cpf }}
                                    </template>
                                    <template v-else>
                                        <i>Não informado</i>
                                    </template>
                                </p>
                                <p>
                                    <strong>Data de nascimento: </strong>
                                    <template v-if="paciente.dataNascimento">
                                        {{ paciente.dataNascimento }}
                                    </template>
                                    <template v-else>
                                        <i>Não informado</i>
                                    </template>
                                </p>
                            </rkm-col>

                            <rkm-col cols="4">
                                <p>
                                    <strong>CNS: </strong>
                                    <template v-if="paciente.cns">
                                        {{ paciente.cns }}
                                    </template>
                                    <template v-else>
                                        <i>Não informado</i>
                                    </template>
                                </p>
                                <p>
                                    <strong>Idade:</strong>
                                    <template>
                                        {{ paciente.idade }}
                                    </template>
                                </p>
                            </rkm-col>

                            <rkm-col cols="2">
                                <p>
                                    <strong>RG: </strong>
                                    <template v-if="paciente.rg">
                                        {{ paciente.rg }}
                                    </template>
                                    <template v-else>
                                        <i>Não informado</i>
                                    </template>
                                </p>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="12">
                                <p>
                                    <strong>Telefones: </strong>
                                    <template v-if="paciente.telefones">
                                        {{ paciente.telefones }}
                                    </template>
                                    <template v-else>
                                        <i>Não informado</i>
                                    </template>
                                </p>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="9">
                                <p>
                                    <strong>Responsável pelo cadastro: </strong>
                                    <template v-if="paciente.responsavelCadastro">
                                        {{ paciente.responsavelCadastro }}
                                    </template>
                                    <template v-else>
                                        <i>Não informado</i>
                                    </template>
                                </p>
                                <p>
                                    <strong>Unidade de Referência:</strong>
                                    <template v-if="paciente.unidadeReferencia">
                                        {{ paciente.unidadeReferencia }}
                                    </template>
                                    <template v-else>
                                        <i>Não informado</i>
                                    </template>
                                </p>
                            </rkm-col>

                            <rkm-col cols="3">
                                <p>
                                    <strong>Classificação: </strong>
                                    <template v-if="paciente.classificacaoNome">
                                        {{ paciente.classificacaoNome }}
                                    </template>
                                    <template v-else>
                                        <i>Não informado</i>
                                    </template>
                                </p>
                                <p>
                                    <strong>Área/Microárea: </strong>
                                    <template v-if="paciente.areaMicroarea">
                                        {{ paciente.areaMicroarea }}
                                    </template>
                                    <template v-else>
                                        <i>Não informado</i>
                                    </template>
                                </p>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                v-if="form && endereco.tipo"
                title="Endereço"
                type="fieldset"
                no-margin-top
            >
                <rkm-row>
                    <rkm-col class="flex-grow-1">
                        <rkm-row>

                            <rkm-col cols="10">
                                <p>
                                    <strong>Endereço: </strong>
                                    <template v-if="endereco.logradouro">
                                        {{ endereco.logradouro.tipoNome }}, {{ endereco.numero }} {{ endereco.complemento }}
                                        - {{ endereco.bairro }}, {{ endereco.municipio }} - {{ endereco.uf }} - {{ endereco.cep }}
                                    </template>
                                </p>
                            </rkm-col>

                            <rkm-col cols="2">
                                <p>
                                    <strong>Código IBGE: </strong>
                                    <template v-if="endereco.ibge">
                                        {{ endereco.ibge }}
                                    </template>
                                    <template v-else>
                                        <i>Não informado</i>
                                    </template>
                                </p>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                title="Dados da consulta"
                type="fieldset"
                no-margin-top
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :searchFields="localForm.autocompleteFields.motivo"
                            :repository="repositories.motivo"
                            v-model="model.motivo"
                            textField="descricao"
                            :validations="validations.motivo"
                            label="Motivo da viagem"
                            uppercase
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            label="Data"
                            v-model="model.data"
                            :validations="validations.data"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            label="Horário da Consulta/Procedimento"
                            v-model="model.horario"
                            :validations="validations.horario"
                            :disabled="!model.data"
                            right
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.municipios"
                            text-field="nome"
                            value-field="id"
                            label="Município"
                            v-model="model.municipio"
                            :validations="validations.municipio"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="destinos"
                            text-field="descricao"
                            value-field="id"
                            label="Local"
                            v-model="model.destinoId"
                            @change="setFields('destinoId')"
                            :disabled="!model.municipio"
                            :validations="model.municipio ? validations.destino : {}"
                            show-default-option
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    @click="$refs.ModalAgendado.open(model.data, form.municipios.find(municipio => municipio.id == model.municipio))"
                                    color="primary"
                                    title="Viagens agendadas"
                                    :disabled="!model.data || !model.municipio"
                                >
                                    <rkm-icon icon="search" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-select>
                    </rkm-col>

                    <rkm-col cols="12">
                        <rkm-form-textarea
                            label="Observação do transporte"
                            v-model="model.consultaObservacao"
                            name="observacao"
                            rows="1"
                            max-rows="1"
                        >
                        </rkm-form-textarea>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                title="Dados do transporte"
                type="fieldset"
                no-margin-top
            >
                <rkm-row>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="form.acompanhante"
                            text-field="text"
                            value-field="value"
                            :label="form.paciente.requiredAcompanhante ? 'Acompanhante(s) *' : 'Acompanhante(s)'"
                            v-model="model.acompanhante"
                            @change="handleAcompanhante()"
                            :validations="validations.acompanhante"
                        />
                    </rkm-col>

                    <rkm-col cols="5">
                        <rkm-form-select
                            :options="form.pontos"
                            text-field="descricao"
                            value-field="id"
                            label="Ponto de referência do(a) paciente"
                            v-model="model.pontoId"
                            :validations="validations.ponto"
                            show-default-option
                            @change="handleDataSaida()"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-date-picker
                            label="Data saída"
                            v-model="model.dataSaida"
                            :max-date="formatDate()"
                            :disabled="!model.data || !model.pontoId"
                            :validations="validations.dataSaida"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            label="Horário de saída do veículo"
                            v-model="model.horarioSaida"
                            :validations="form.horarioSaida || model.horarioSaida ? validations.horarioSaida : {}"
                            :disabled="!model.dataSaida || !model.horario"
                            right
                        />
                    </rkm-col>

                    <rkm-col cols="2" v-if="form.agendarTransporteJornada">
                        <rkm-form-select
                            :options="form.tiposPassageiro"
                            :validations="validations.tipoPassageiro"
                            label="Tipo de passageiro"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.tipoPassageiroId"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col cols="5">
                        <rkm-form-select
                            :options="veiculos"
                            text-field="descricao"
                            value-field="id"
                            label="Veículo"
                            v-model="model.veiculoId"
                            @change="setFields('veiculoId')"
                            :disabled="!model.tipoPassageiroId && form.agendarTransporteJornada || !model.municipio && !form.agendarTransporteJornada"
                            :validations="form.veiculoObrigatorio ? validations.veiculo : {}"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col cols="5">
                        <rkm-form-select
                            :options="optionsJornada"
                            text-field="descricao"
                            value-field="id"
                            label="Jornada"
                            v-model="model.jornadaId"
                            :disabled="!model.tipoPassageiroId && form.agendarTransporteJornada && !model.veiculoId || !model.municipio && !form.agendarTransporteJornada || !model.veiculoId"
                            :validations="form.veiculoObrigatorio && form.agendarTransporteJornada ? validations.jornada : {}"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col
                        cols="2"
                        v-if="showVeiculo()"
                    >
                        <rkm-form-input
                            label="Agendados"
                            type="number"
                            v-model="model.totalAgendados"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="2" v-if="showVeiculo()">
                        <rkm-form-input
                            label="Capacidade"
                            type="number"
                            v-model="model.capacidade"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="3" v-if="showVeiculo()">
                        <rkm-form-select
                            :options="form.tiposVeiculo"
                            text-field="descricao"
                            value-field="id"
                            label="Tipo de veículo"
                            v-model="model.tipoVeiculoId"
                            show-default-option
                            disabled
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                v-if="form.dadosAcompanhante && model.acompanhante > 0"
                title="Acompanhante 1"
                type="fieldset"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            v-if="form.campoLivre"
                            label="Nome"
                            v-model="model.nome1"
                            uppercase
                            :validations="validations.acompanhante1"
                        />

                        <rkm-form-input-autocomplete
                            v-else
                            :repository="repositories.paciente"
                            :search-fields="fields.paciente"
                            :text-field="(item) => item.cidadao.nome"
                            label="Nome"
                            v-model="model.acompanhante1"
                            uppercase
                            :validations="validations.acompanhante1"
                            @select="handleAcompanhante1Select"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            label="CNS"
                            v-mask="mask.cns"
                            :value="acompanhante1Cns"
                            :disabled="!form.campoLivre"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            v-if="!model.telefone1"
                            :validations="validations.telefone1"
                            label="Telefone"
                            v-model="model.telefone1"
                        />

                        <rkm-form-input
                            v-else
                            :validations="validations.telefone1"
                            label="Telefone mask"
                            v-mask="telefone1Mask"
                            v-model="model.telefone1"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Relação"
                            :options="form.relacoes"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            v-model="model.relacao1"
                            :validations="validations.relacao"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                v-if="form.dadosAcompanhante && model.acompanhante > 1"
                title="Acompanhante 2"
                type="fieldset"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            v-if="form.campoLivre"
                            label="Nome"
                            v-model="model.nome2"
                            uppercase
                            :validations="validations.acompanhante2"
                        />

                        <rkm-form-input-autocomplete
                            v-else
                            :repository="repositories.paciente"
                            :search-fields="fields.paciente"
                            :text-field="(item) => item.cidadao.nome"
                            label="Nome"
                            v-model="model.acompanhante2"
                            uppercase
                            :validations="validations.acompanhante2"
                            @select="handleAcompanhante2Select"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            label="CNS"
                            :value="acompanhante2Cns"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            v-if="!model.telefone2"
                            :validations="validations.telefone2"
                            label="Telefone"
                            v-model="model.telefone2"
                        />

                        <rkm-form-input
                            v-else
                            :validations="validations.telefone2"
                            label="Telefone"
                            v-mask="telefone2Mask"
                            v-model="model.telefone2"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Relação"
                            :options="form.relacoes"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            v-model="model.relacao2"
                            :validations="validations.relacao"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                title="Observação do paciente"
                type="fieldset"
                no-margin-top
            >
                <rkm-row>

                    <rkm-col cols="12">
                        <rkm-form-textarea
                            v-model="model.observacao"
                            name="observacao"
                            rows="1"
                            max-rows="1"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-button
                            color="primary"
                            :label="false"
                            @click="salvarObservacao()"
                        >
                            Incluir
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <ModalAgendado
            ref="ModalAgendado"
        />

        <ModalPreAgendar
            ref="ModalPreAgendar"
            :form="form"
            :model="model"
            @handlePreAgendar="handlePreAgendar"
        />

        <ModalPermissao
            ref="RkmModalPermissao"
            @handlePermission="handlePermission"
        />

        <ModalListaAgendamento ref="ModalListaAgendamento" />
    </div>
</template>

<script>

// Moment.
import moment from 'moment'

// Filters.
import format from '@/filters/formats'

//Enuns.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import status from '@/enums/transporte-paciente/agendar-transporte/status'
import racaCor from '@/enums/cadastro/cidadao/racaCor'
import classificacao from '@/enums/cadastro/paciente/classificacao'

// Components.
import ModalAgendado from '@/components/transporte-paciente/agendar/agendados/Modal'
import ModalPreAgendar from '@/components/transporte-paciente/agendar/pre-agendar/Modal'
import ModalPermissao from '@/components/transporte-paciente/agendar/permissao/Modal'
import ModalListaAgendamento from '@/components/transporte-paciente/agendar/components/agendamento/Modal'

// Mixins.
import { error, permissao, repository, stringCase, data, object, printTransportePacienteAgendar, mask, unmask } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Utils
import validaCpf from '@/utils/validations/cpf'
import validaCns from '@/utils/validations/cns'

export default {
    components: {
        ModalAgendado,
        ModalPreAgendar,
        ModalPermissao,
        ModalListaAgendamento,
    },
    computed: {
        acompanhante1Cns() {
            return this.model.acompanhante1?.cidadao ? format.formatCns(this.model.acompanhante1.cidadao.cns) : null
        },
        acompanhante2Cns() {
            return this.model.acompanhante2?.cidadao ? format.formatCns(this.model.acompanhante2.cidadao.cns) : null
        },
        validations() {
            const validations = {
                motivo: { required: true },
                data: { required: true },
                horario: { required: true },
                municipio: { required: true },
                destino: { required: true },
                acompanhante: { min_value: this.form.paciente.requiredAcompanhante ? 1 : 0 },
                ponto: { required: true },
                dataSaida: { required: true },
                horarioSaida: {
                    required: true,
                    max_hour: this.getFormatedDate(this.model.data, 'YYYY-MM-DD') === this.getFormatedDate(this.model.dataSaida, 'YYYY-MM-DD')
                        ? this.getMaxHour() : false
                },
                tipoPassageiro: { required: true },
                veiculo: { required: true },
                jornada: { required: true },
                acompanhante1: { required: true },
                acompanhante2: { required: true },
                relacao: { required: true },
                telefone1: {
                    min_max_without_mask: [10, 11],
                },
                telefone2: {
                    min_max_without_mask: [10, 11],
                },
            };

            if (this.model.acompanhante === 0) {

                delete validations.acompanhante;
            }

            return validations;
        },
        optionsJornada() {

            if (this.model.horarioSaida && !this.model.jornadaId) {

                const dataHoraSaida = this.getFormatedDate(this.model.dataSaida, 'YYYY-MM-DD') + ' ' + this.model.horarioSaida;

                if (!dataHoraSaida) {
                    return [];
                }

                return this.jornadas?.filter(jornada =>
                    jornada.dataInicial <= dataHoraSaida && jornada.dataFinal >= dataHoraSaida) ?? [];
            } else {

                const dataHoraSaida = this.getFormatedDate(this.model.dataSaida, 'YYYY-MM-DD')

                if (!dataHoraSaida) {
                    return [];
                }

                return this.jornadas?.filter(jornada =>
                    this.getFormatedDate(jornada.dataInicial, 'YYYY-MM-DD') <= dataHoraSaida
                    && this.getFormatedDate(jornada.dataFinal, 'YYYY-MM-DD') >= dataHoraSaida) ?? [];
            }
        },
        fields() {

            return {
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
            }
        },
        telefone1Mask() {
            let numeroTelefone = this.unMaskPhone(this.model.telefone1)

            if (!numeroTelefone) {

                return ''
            }

            return numeroTelefone.length < 11 ? this.mask.phone : this.mask.cellPhone
        },
        telefone2Mask() {
            let numeroTelefone = this.unMaskPhone(this.model.telefone2)

            if (!numeroTelefone) {

                return ''
            }

            return numeroTelefone.length < 11 ? this.mask.phone : this.mask.cellPhone
        },
    },
    created() {

        this.repositories.agendar = this.getConectaSusRepository('transportePaciente.agendar')
        this.repositories.motivo = this.getConectaSusRepository('transportePaciente.motivo')
        this.repositories.municipio = this.getConectaSusRepository('intranet.municipio'),
        this.repositories.paciente= this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),

        this.load()
    },
    data: () => ({
        additionals: null,
        repositories: {
            agendar: null,
            motivo: null,
            municipio: null,
            paciente: null,
        },
        form: null,
        localForm: {
            autocompleteFields: {
                motivo: [
                    { key: 'descricao', searchable: true },
                ],
                municipio: [
                    {
                        key: 'nome',
                        searchable: true,
                    },
                ],
            },
        },
        model: null,
        destinos: [],
        veiculos: [],
        jornadas: [],
        pontos: [],
        tiposPassageiro: [],
        agendamentoPaciente: [],
        enums: {
            preferenciaNome,
            status,
            racaCor,
            classificacao
        },
        utils: {
            validaCpf,
            validaCns
        },
        paciente: {
            id: null,
            nome: null,
            preferenciaNomeId: null,
            nomeSocial: '',
            prontuario: null,
            cpf: null,
            cns: null,
            telefones: null,
            dataNascimento: null,
            classificacaoId: null,
            idade: null,
            anos: null,
            meses: null,
            dias: null,
            sexo: null,
            sexoId: null,
            sexoDescricao: '',
            nomeMae: '',
            convenioMedicoNome: '',
            classificacaoNome: '',
            responsavelCadastro: '',
            areaMicroarea: '',
        },
        endereco: {
            tipo: null,
            logradouro: null,
            numero: null,
            complemento: null,
            bairro: null,
            cep: null,
            municipio: null,
            uf: null,
        },
        fieldMap: [
            'data',
            'horario',
            'municipio',
            'destinoId',
            'pontoId',
            'horarioSaida',
            'tipoPassageiroId',
            'veiculoId',
            'jornadaId',
        ],
        atribuirPreAgendar: false
    }),
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        salvarObservacao() {
            this.setLoading()
            this.repositories.agendar.salvarObservacao({
                id: this.id,
                observacao: this.model.observacao
            })
                .then(() => {
                    this.showSaveNotification()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        convertBooleanToBinary: (valor) => valor ? 1 : 0,
        trataNull: (valor) => valor === undefined || valor == null ? null : valor,
        load() {
            this.setLoading()

            this.repositories.agendar.show(this.id)
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.setData(data.form || null, data.model || null)
                    this.$emit('permissao', data.form)

                    this.$emit('loaded', {additionals: this.additionals, form: this.form})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {
            if (form) {

                this.form = Object.assign(form)
            }

            if (model) {

                this.model = Object.assign(model)
                this.model.bloqueado = this.model.bloqueado == 1
            }

            this.loadPaciente(form.paciente)
            this.loadEndereco(form.endereco)
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid) {

                        if (!this.validateForm()) {
                            return
                        }

                        const dataHoraSaida = this.getFormatedDate(
                            this.model.dataSaida,
                            "YYYY-MM-DD"
                        );

                        const horarioSaida = this.agendamentoPaciente.filter(
                            jornada =>
                                this.getFormatedDate(jornada.dataInicial, "YYYY-MM-DD") <=
                                    dataHoraSaida &&
                                this.getFormatedDate(jornada.dataFinal, "YYYY-MM-DD") >=
                                    dataHoraSaida
                        );

                        if (horarioSaida.length > 0) {

                            const confirm = async () => {

                                this.confirmSave()
                            }

                            let msg = 'O paciente tem uma ou mais viagens agendadas para o mesmo dia do procedimento escolhido:'

                            horarioSaida.map(consulta => {

                                msg = msg.concat(`<br><br>
                                    Destino: <strong>${consulta.destino} - ${consulta.municipio} - ${consulta.uf}</strong><br>
                                    Data: <strong>${consulta.data} - ${consulta.horario} (${this.handlePeriodo(consulta.horario)})</strong><br>
                                    Motivo da viagem: <strong>${consulta.motivoDescricao}</strong><br>
                                    Horário de saída do veículo: <strong>${consulta.horarioSaida}</strong>
                                `)
                            })

                            msg = msg.concat('<br><br>Deseja continuar?')

                            this.showConfirmation(msg, confirm)

                        } else {
                            this.confirmSave();
                        }
                    }
                })
        },
        confirmSave() {

            this.setLoading()

            this.repositories.agendar.store(this.prepareData())
                .then(response => {

                    this.showSaveNotification()
                    this.$emit('save', response)

                    this.$nextTick(() => this.handlePrint())
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        validateForm() {
            const totalAgendados = Number(this.model.totalAgendados) + Number(this.model.acompanhante ? this.model.acompanhante : 0)

            if (this.model.veiculoId && (totalAgendados + 1) > this.model.capacidade && this.model.supervisorId == null) {

                const msg = `Para continuar com essa viagem, é necessário que sejam informados os dados
                    do supervisor, uma vez que a quantidade de passageiros excede a capacidade máxima do veículo.
                    Deseja continuar?`

                this.showAlert(msg, 'Atenção')

                const confirm = async () => {

                    this.$refs.RkmModalPermissao.open()
                }

                this.showConfirmation(msg, confirm)

                return false
            }

            return true
        },
        handlePermission(supervisorId){

            this.model.supervisorId = supervisorId

            this.save()
        },
        prepareData() {
            const agendar = this.clone(this.model)

            agendar.id = this.trataNull(agendar.id)
            agendar.pacienteId = this.id

            agendar.motivoId = agendar.motivo.id
            agendar.municipioId = agendar.municipio
            agendar.statusId = this.enums.status.AGENDADO

            agendar.telefone1 = agendar.telefone1 ? this.unMaskPhone(agendar.telefone1) : null
            agendar.telefone2 = agendar.telefone2 ? this.unMaskPhone(agendar.telefone2) : null

            this.formateDates(agendar, ['data', 'dataSaida'], 'YYYY-MM-DD')

            delete(agendar.motivo)
            delete(agendar.municipio)

            return this.camelObjectKeysToSnakeRecursive(agendar)
        },
        loadMotivo(motivo) {

            this.$nextTick(() => this.model.motivo = motivo)
        },
        handleClassificacaoBloqueada(paciente) {

            const mensagem = `O cadastro selecionado possui a classificação ${paciente.classificacaoNome} e não pode
                seguir com o agendamento do transporte. Atualize o cadastro.`

            const sair = async () => {

                this.$emit('handleExitPaciente')
            }

            const podeAtualizarClassificacao = this.additionals.permiteAtualizarCadastroPaciente === true
                && this.verificarPermissao('update-cadastro-paciente')

            if (!podeAtualizarClassificacao) {

                this.showWarningNotification(mensagem, sair)

                return
            }

            const atualizarClassificacao = async () => {

                this.$emit('handleAtualizaPaciente')
            }

            this.showWarningConfirmation(
                'Atenção',
                mensagem,
                atualizarClassificacao,
                sair,
                null,
                'Atualizar classificação',
                'Sair'
            )
        },
        loadPaciente(paciente) {

            if (this.additionals.agendamentoClassificacaoBloqueado) {

                this.handleClassificacaoBloqueada(paciente)

                return false
            }


            this.paciente.nome = paciente.nome
            this.paciente.prefereNomeSocial = paciente.prefereNomeSocial
            this.paciente.nomeSocial = paciente.nomeSocial
            this.paciente.telefones = this.handlePhone(paciente.telefones)
            this.paciente.dataNascimento = paciente.dataNascimento
            this.paciente.situacaoFamiliar = paciente.situacaoFamiliar
            this.paciente.rg = paciente.rg
            this.paciente.cpf = paciente.cpf
            this.paciente.classificacaoId = paciente.classificacaoId
            this.paciente.classificacaoNome = paciente.classificacaoNome
            this.paciente.responsavelCadastro = paciente.responsavelCadastro
            this.paciente.areaMicroarea = paciente.areaMicroarea
            this.paciente.convenioMedicoNome = paciente.convenioMedicoNome
            this.paciente.cns = paciente.cns
            this.paciente.prontuario = paciente.prontuario
            this.paciente.unidadeReferencia = paciente.unidade
            this.paciente.sexo = paciente.sexo.descricao
            this.paciente.idade = paciente.idade

            if (!paciente.cns || !this.utils.validaCns(paciente.cns) || !paciente.dataNascimento || !paciente.sexo.id
                || !paciente.nome || !paciente.nacionalidadeId || !paciente.domicilioId || !paciente.racaCorId
                || paciente.racaCorId == this.enums.racaCor.INDIGENA && !paciente.etniaIndigenaId
                || paciente.telefones.length === 0){

                    const confirm = async () => {
                        return true
                    }

                    const cancel = async () => {

                        this.$emit('handleExitPaciente')
                    }

                    const msg = `O cadastro do(a) paciente selecionado(a) está incompleto e a viagem não será faturada.
                        Deseja continuar?`

                        this.showConfirmation(msg, confirm, cancel)

                    return false
            }

            if (paciente.classificacaoId === this.enums.classificacao.PROVISORIO
                || paciente.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO) {

                    const confirm = async () => {
                        return true
                    }

                    const cancel = async () => {

                        this.$emit('handleExitPaciente')
                    }

                    const msg = paciente.classificacaoId === this.enums.classificacao.PROVISORIO
                        ? 'Este paciente tem classificação provisória. Deseja continuar?'
                        : 'Este paciente é de outro município. Deseja continuar?'

                        this.showConfirmation(msg, confirm, cancel)

                    return false
            }
        },
        loadEndereco(endereco) {

            this.endereco.tipo = endereco.logradouro.tipo
            this.endereco.logradouro = endereco.logradouro
            this.endereco.numero = endereco.numero
            this.endereco.complemento = endereco.complemento
            this.endereco.bairro = endereco.logradouro.bairro.nome
            this.endereco.cep = endereco.cep
            this.endereco.municipio = endereco.municipio.nome
            this.endereco.uf = endereco.municipio.estado.uf
            this.endereco.ibge = endereco.municipio.ibge
        },
        handlePhone(obj) {

            let telefones = ''

            Object.keys(obj).forEach(function(value, i) {

                if (i === 0) {
                    telefones = telefones.concat(obj[value])
                } else {
                    telefones = telefones.concat(`, ${obj[value]}`)
                }
            });

            return telefones
        },
        getDestinos() {

            this.setLoading()

            this.repositories.agendar.getDestinos({
                'municipio_id': this.model.municipio
            })
                .then(({ data }) => {

                    this.destinos = data

                    if (this.destinos.length === 0) {

                        this.showAlert(`Para prosseguir, é necessário cadastrar um destino para a cidade informada,
                            pois não há nenhum destino registrado atualmente.`, 'Atenção')

                        return
                    }

                    if(data.length == 1) {
                        this.model.destinoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getAgendadosPaciente() {

            this.setLoading()

            const dataSaida = this.model.dataSaida

            this.repositories.agendar.getAgendadosPaciente({
                'data_saida': `${this.getFormatedDate(dataSaida, 'YYYY-MM-DD')}`,
                'paciente_id': this.id,
            })
                .then(({ data }) => {

                    this.agendamentoPaciente = data

                    if (this.form.agendarTransporteJornada) {

                        this.handleJornada(data)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())

        },
        validarDuplicidade(){
            this.setLoading()
            const dataSaida = this.model.dataSaida

            this.repositories.agendar.getAgendadosPaciente({
                'data_saida': `${this.getFormatedDate(dataSaida, 'YYYY-MM-DD')}`,
                'paciente_id': this.id,
            })
            .then(({data})=> {
                this.agendamentoPaciente = data;

                const motivo = this.model.motivo.id
                const dataAgendamento = this.getFormatedDate(this.model.data,'DD/MM/YYYY')
                const municipio = this.model.municipio
                const local = this.model.destinoId
                const hora_saida = this.model.horario.slice(0, 5);

                let tam = this.agendamentoPaciente.length

                for(let i=0; i < tam; i ++){
                    if(dataAgendamento == this.agendamentoPaciente[i].data &&
                       local == this.agendamentoPaciente[i].destinoId &&
                       municipio == this.agendamentoPaciente[i].municipioId &&
                       motivo == this.agendamentoPaciente[i].motivoId &&
                       hora_saida == this.agendamentoPaciente[i].horarioSaida
                    ){
                        this.showAlert(`Este paciente já está agendado para uma viagem na mesma data, motivo, município e local.`, 'Atenção')
                        break;
                    }
                }

            })
            .catch(this.handleError)
            .finally(() => {
                this.unsetLoading();
            });
        },
        handleJornada(data) {

            const agendamento = data.find(a => a.jornadaId === this.model.jornadaId)

            if (agendamento) {

                this.showAlert(`Este paciente já está agendado nesta jornada (mesmo veículo e horário), portanto não é
                    necessário cadastrá-lo novamente.`, 'Atenção')

                const index = this.jornadas.findIndex(jornada => jornada.id === agendamento.jornadaId)
                this.jornadas.splice(index,1)
                
                if(this.jornadas.length > 0){
                    this.model.jornadaId = this.jornadas[0].id
                    this.model.horarioSaida = this.jornadas[0].dataInicial.split(" ")[1].substring(0, 5)
                } else {
                    this.model.jornadaId = null
                }

                return
            }

            const dataHoraSaida = this.getFormatedDate(this.model.dataSaida, 'YYYY-MM-DD') + ' ' + this.model.horarioSaida

            if (dataHoraSaida) {

                let agendamentos = data.filter(a => a.dataInicial <= dataHoraSaida && a.dataFinal >= dataHoraSaida)

                if (agendamentos.length > 0) {

                    this.$refs.ModalListaAgendamento.open(agendamentos, () => this.model.jornadaId = null)
                }
            }
        },
        getVeiculos() {

            this.setLoading()

            this.resetVeiculos()

            const dataSaida = this.model.dataSaida

            this.repositories.agendar.getVeiculos({
                'agendar_transporte_jornada': this.form.agendarTransporteJornada,
                'tipo_passageiro_id': this.model.tipoPassageiroId,
                'data_saida': this.getFormatedDate(dataSaida, 'YYYY-MM-DD'),
                'horario_saida': this.model.horarioSaida
            })
                .then(({ data }) => {

                    this.veiculos = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getJornadas() {

            this.setLoading()

            const dataSaida = this.model.dataSaida

            this.repositories.agendar.getJornadas({
                'veiculo_id': this.model.veiculoId,
                'data_saida': `${this.getFormatedDate(dataSaida, 'YYYY-MM-DD')}`,
            })
                .then(({ data }) => {

                    if(data.length === 1) {
                        this.model.jornadaId = data[0].id
                    }

                    this.jornadas = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        validarDataEHora() {

            const formattedData = this.getFormatedDate(this.model.data, 'YYYY-MM-DD');
            const formattedDataSaida = this.getFormatedDate(this.model.dataSaida, 'YYYY-MM-DD');

            if (formattedData === formattedDataSaida) {

                if (this.model.horarioSaida) {

                    return this.model.horario > this.model.horarioSaida;
                } else {

                    return true;
                }
            } else {

                return true;
            }
        },
        getMaxHour() {

            const horario = this.model.horario

            if (horario) {

                return moment(horario, 'HH:mm').subtract(1, 'minutes').format('HH:mm')
            }

            return false
        },
        formatDate() {

            const data = this.model.data

            if (data) {

                return moment(data, 'DD/MM/YYYY').format('DD/MM/YYYY')
            }

            return ''
        },
        setFields(value) {

            if (!this.atribuirPreAgendar) {

                const index = this.fieldMap.indexOf(value);
                const field = this.fieldMap[index + 1];

                if (field && this.model[field] !== null) {

                    for (const ref of Object.values(this.$refs)) {

                        if (ref.validate) {
                            ref.resetValidator();
                        }
                    }

                    this.$set(this.model, field, null);
                    this.setFields(field);
                }
            }
        },
        handleDataSaida() {

            this.setFields('pontoId')
        },
        handlePeriodo(horario) {

            if (horario < '12:00') {

                return "Turno da manhã"
            } else if (horario < '18:00') {

                return "Turno da tarde"
            } else {

                return "Turno da noite"
            }
        },
        handlePrint() {
            let agendamento = {
                pacienteNome: this.form.paciente.nome,
                pacienteNomeSocial: this.form.paciente.nomeSocial,
                dataNascimento: this.form.paciente.dataNascimento,
                prontuario: this.form.paciente.prontuario,
                telefonePaciente: this.form.paciente.telefones,
                logotipo: this.form.cliente.logotipo,
                nomePrefeitura: this.form.cliente.nome,
                ramoAtividade: this.form.cliente.sistema.ramoAtividade.nome,
                mensagemProtocolo: this.form.mensagemProtocolo,
                sistemaNome: this.form.cliente.sistema.nome,
                sistemaVersao: this.form.cliente.sistema.versao,
                usuario: this.form.usuario,
                acompanhantes: this.model.acompanhante ? this.model.acompanhante : 'NÃO',
                comprovanteAcompanhante: this.form.comprovanteAcompanhante,
                acompanhante1Nome: this.model.nome1 ?? this.model.acompanhante1?.cidadao?.nome,
                acompanhante1Cns: this.acompanhante1Cns,
                acompanhante1Telefone: this.model.telefone1,
                acompanhante1Relacao: this.form.relacoes.find(relacao => relacao.id == this.model.relacao1)?.descricao ?? null,
                acompanhante2Nome: this.model.nome2 ?? this.model.acompanhante2?.cidadao?.nome,
                acompanhante2Cns: this.acompanhante2Cns,
                acompanhante2Telefone: this.model.telefone2,
                acompanhante2Relacao: this.form.relacoes.find(relacao => relacao.id == this.model.relacao2)?.descricao ?? null,
                dataSaida: this.getFormatedDate(this.model.dataSaida, 'DD/MM/YYYY'),
                horarioSaida: this.model.horarioSaida
                    ? moment(this.model.horarioSaida, 'HH:mm').format('HH:mm')
                    : 'NÃO INFORMADO',
                motivo: this.model.motivo ? this.model.motivo.descricao : 'NÃO INFORMADO',
                ponto: this.model.pontoId
                    ? this.form.pontos.find(p => p.id === this.model.pontoId).descricao : 'NÃO INFORMADO',
                destino: this.model.destinoId
                    ? this.destinos.find(p => p.id === this.model.destinoId).descricao : 'NÃO INFORMADO',
                veiculo: this.model.veiculoId
                    ? this.veiculos.find(p => p.id === this.model.veiculoId).descricao : 'NÃO INFORMADO',
                telefoneUnidadeAgendadora: this.form.paciente.telefoneUnidadeAgendadora,
                observacao: this.model.consultaObservacao ?? null
            }
            this.print().agendar(agendamento)
        },
        resetVeiculos() {

            this.veiculos = []

            if (!this.atribuirPreAgendar) {
                this.model.veiculoId = null
                this.model.capacidade = null
                this.model.totalAgendados = null
                this.model.tipoVeiculoId = null
            }
        },
        showVeiculo() {

            return this.form.agendarTransporteJornada && this.model.jornadaId
                || !this.form.agendarTransporteJornada && this.model.veiculoId
        },
        preAgendar() {

            this.$refs.ModalPreAgendar.open()
        },
        handlePreAgendar(selecionado){
            if (selecionado) {

                this.atribuirPreAgendar = true
                this.model.data = selecionado.preAgendamentoData
                this.model.horario = selecionado.horario
                this.model.municipio = selecionado.municipioId
                this.model.motivo = {
                    id: selecionado.motivoId,
                    descricao: selecionado.transportePacienteMotivo
                }
                this.model.destinoId = selecionado.destinoId
                this.model.pontoId = selecionado.pontoId
                this.model.acompanhante = selecionado.acompanhante
                this.model.acompanhante1 = selecionado.acompanhante1
                this.model.relacao1 = selecionado.relacao1
                this.model.acompanhante2 = selecionado.acompanhante2
                this.model.relacao2 = selecionado.relacao2
                this.model.consultaObservacao = selecionado.observacao
                this.model.dataSaida = selecionado.dataSaida
                this.model.horarioSaida = selecionado.horarioSaida
                this.model.tipoPassageiroId = selecionado.tipoPassageiroId
                this.model.veiculoId = selecionado.veiculoId
                this.model.jornadaId = selecionado.jornadaId
                this.model.capacidade = selecionado.veiculoCapacidade
                this.model.totalAgendados = selecionado.agendados
                this.model.tipoVeiculoId = selecionado.veiculoTipoId
                this.model.preAgendamentoId = selecionado.id
            }

            this.$nextTick(() => this.atribuirPreAgendar = false)
        },
        handleAcompanhante() {

            if (this.model.acompanhante < 1) {

                this.model.acompanhante1 = null

            }
            if (this.model.acompanhante < 2) {

                this.model.acompanhante2 = null
            }
        },
        handleAcompanhante1Select(acompanhante) {
            this.model.telefone1 = acompanhante?.cidadao?.telefonePrincipal ? acompanhante.cidadao.telefonePrincipal.numero : null
        },
        handleAcompanhante2Select(acompanhante) {
            this.model.telefone2 = acompanhante?.cidadao?.telefonePrincipal ? acompanhante.cidadao.telefonePrincipal.numero : null
        },
    },
    mixins: [ error, permissao, repository, stringCase, data, object, printTransportePacienteAgendar, mask, unmask ],
    props: {
        id: { type: [Number], default: null }
    },
    watch: {
        'model.data': function (data) {

            if (data) {

                this.model.dataSaida = data
            }

            this.setFields('data')
        },
        'model.municipio': function (municipio) {

            if (municipio) {
                this.getDestinos()
                this.validarDuplicidade();

                if (!this.form.agendarTransporteJornada) {

                    this.getVeiculos()
                    this.getJornadas()
                }
            }

            this.setFields('municipio')
        },
        'model.dataSaida': function (dataSaida) {

            if (dataSaida) {

                this.getVeiculos()
                this.getJornadas()

                if (!this.atribuirPreAgendar) {

                    this.model.horarioSaida = null
                }
            }

            this.setFields('pontoId')
        },
        'model.horarioSaida': function () {


            if (!this.model.jornadaId) {

                this.setFields('horarioSaida')
            }
        },
        'model.tipoPassageiroId': function (tipoPassageiro) {

            if (tipoPassageiro) {

                this.getVeiculos()
            }

            this.setFields('tipoPassageiroId')
        },
        'model.veiculoId': function (tipoVeiculo) {

            if (tipoVeiculo) {

                this.getJornadas()
                const veiculo = this.veiculos.find(v => v.id === this.model.veiculoId)

                if (veiculo) {
                    this.model.capacidade = veiculo.capacidade
                    this.model.totalAgendados = veiculo.agendados ? veiculo.agendados.quantidade : 0
                    this.model.tipoVeiculoId = veiculo.tipoId
                }
            } else {
                this.getJornadas()
            }
        },
        'model.jornadaId': function (jornadaId) {

            if (jornadaId) {

                this.getAgendadosPaciente()

                const jornada = this.jornadas.find(jornada => jornada.id === jornadaId)

                if (jornada) {
                    this.model.capacidade = jornada.numeroCapacidade
                    this.model.totalAgendados = jornada.totalAgendados
                    this.model.tipoVeiculoId = jornada.tipoId
                }

                if (!this.model.horarioSaida) {

                    this.model.horarioSaida = jornada.dataInicial.split(" ")[1].substring(0, 5)
                }

                if (!this.model.veiculoId) {

                    const veiculo = this.veiculos.find(v => v.id === jornada.veiculoId)

                    if (veiculo) {
                        this.model.veiculoId = jornada.veiculoId
                    }
                }
            } else {

                this.model.capacidade = null
                this.model.totalAgendados = null
                this.model.tipoVeiculoId = null

                const veiculo = this.veiculos.find(v => v.id === this.model.veiculoId)

                if (veiculo) {

                    this.model.capacidade = veiculo.capacidade
                    this.model.totalAgendados = veiculo.agendados
                        ? (Number(veiculo.agendados.quantidade) - Number(this.model.acompanhante)) - 1
                        : 0
                    this.model.tipoVeiculoId = veiculo.tipoId
                }
            }

            this.setFields('jornadaId')
        },
        'model.acompanhante1': function (acompanhante) {
            if (this.form.paciente.requiredAcompanhante && acompanhante) {

                if (acompanhante.cidadao.idade.anos > 80 || acompanhante.cidadao.idade.anos < 8) {

                    this.showAlert('O acompanhante deve estar na faixa etária entre 08 e 80 anos.', 'Atenção!')

                    this.model.acompanhante1 = null

                    return false
                }

                if (!acompanhante.cidadao.cns || !this.utils.validaCns(acompanhante.cidadao.cns) || !acompanhante.cidadao.dataNascimento || !acompanhante.cidadao.sexo.id
                    || !acompanhante.cidadao.nome || !acompanhante.cidadao.nacionalidadeId || !acompanhante.cidadao.domicilioId || !acompanhante.cidadao.racaCorId
                    || acompanhante.cidadao.racaCorId == this.enums.racaCor.INDIGENA && !acompanhante.cidadao.etniaIndigenaId
                    || acompanhante.cidadao.telefones.length === 0){

                        const confirm = async () => {

                            if (!acompanhante) {
                                this.model.acompanhante1 = null
                            }
                        }

                        const cancel = async () => {

                            this.model.acompanhante1 = null
                        }

                        const msg = `O cadastro do(a) acompanhante selecionado(a) está incompleto e a viagem não
                            será faturada. Deseja continuar?`

                            this.showConfirmation(msg, confirm, cancel)

                        return false
                } else {

                    if (!acompanhante) {
                        this.model.acompanhante1 = null
                    }
                }
            } else {

                if (!acompanhante) {
                    this.model.acompanhante1 =  null
                }
            }
        },
        'model.acompanhante2': function (acompanhante) {
            if (!acompanhante) {
                this.model.acompanhante2 = null

            }
        }
    },
}
</script>

<style scoped>
p {
    margin: 0px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}
</style>